/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlQueryExecutionStatus } from '../models/SqlQueryExecutionStatus';

export class SqlQueryExecution {
  /**
  * The unique identifier of the SQL query execution
  */
  'id': string;
  /**
  * The ID of the SQL engine the query runs on
  */
  'sqlEngineId': string;
  /**
  * The name of the SQL engine (snapshot at execution time)
  */
  'sqlEngineName': string;
  /**
  * The type of the SQL engine (snapshot at execution time)
  */
  'sqlEngineType': string;
  /**
  * The SQL query text
  */
  'query': string;
  'status': SqlQueryExecutionStatus;
  /**
  * The timestamp when the query execution was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the query execution finished
  */
  'finishedAt'?: Date | null;
  /**
  * The project ID this query execution belongs to
  */
  'projectId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "sqlEngineId",
      "baseName": "sqlEngineId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "sqlEngineName",
      "baseName": "sqlEngineName",
      "type": "string",
      "format": ""
    },
    {
      "name": "sqlEngineType",
      "baseName": "sqlEngineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SqlQueryExecutionStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "finishedAt",
      "baseName": "finishedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return SqlQueryExecution.attributeTypeMap;
  }

  public constructor() {
  }
}



